var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowAnimation)?_c('transition',{attrs:{"name":"slide"}},[(_vm.showElement)?_c('div',{staticClass:"sticky-buttons-wrapper",class:{ loading: _vm.loading }},[_vm._t("default")],2):_vm._e()]):_c('div',{staticClass:"sticky-buttons-wrapper",class:{ loading: _vm.loading }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }